<template>
  <div style="width: 100%;height: 9.375rem; background: #fff; padding: 0px;">
    <el-container style="width: 100%;height: 100%;">

      <el-main>
        <p
          style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 1.5625rem;color: #313131;margin-top: 1rem;">
          &#160;&#160;{{Num}}&#160;{{titleStr}}
        </p>
        <p
          style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 0.9375rem;color: #acaaaa;margin-top: -1.5rem;">
          $ {{USDT}}
        </p>
          <!-- <ExtractHomeHead ref="ExtractHomeHead" style="width: 100%;"></ExtractHomeHead> -->
        <!-- <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
          <div class="CodeForm">

            <p style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 1.5625rem;">BTC Address</p>

            <div id="qqq">
              <div id="qrCode" ref="qrCodeDiv"></div>
            </div>
            <p id="codeText" style="width: 100%;text-align: center;">xxxxxxxxxxxxxxx</p>

            <mu-button @click="submit($event)" class="copyBtn">Copy the above address</mu-button>
          </div>
        </mu-flex> -->

      </el-main>
      <el-footer>
        <el-button @click="WithdrawClick" class="ETLBtn" fill>Withdraw</el-button>
        <el-button @click="DepositClick" class="ETLBtn" fill>Deposit</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        titleStr:'',
        Num:'0',
        USDT:'0'
      }
    },
    mounted() {
  //     var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
  //     this.UserType = UserInfo.type;

  //     window.T_Details = this;
  // console.log(this.$route.query.Name)
      // this.titleStr = this.$route.query.Name;

      // this.loadOrder();
    },
    methods: {
      WithdrawClick(){
        // console.log(this.titleStr)
        // console.log(this.Num)
        this.$router.push({
          path: '/M/Withdraw',
          query: {
            Name:this.titleStr,
            Num:this.Num,
            USDT:this.USDT
          }
        })
      },
      DepositClick(){
        // console.log("2222222"+this.titleStr);
        this.$router.push({
          path: '/M/Deposit',
          query: {
            Name:this.titleStr
          }
        })
      }
    },
    components: {
    }
  };
</script>

<style>
  #ExtractHome .ETLBtn {
    margin: 0.625rem; /*水平居中*/
    /* display: flex; */
    /* padding: 30px; */
    font-size: 15px;
    color: #FFFFFF;
    background-color: #303644;
    border-radius: 30px;
    width: 9.375rem;
  }
  #ExtractHome .el-footer {
      margin: 0 auto;
      padding: 0;
      background-color: #fff;
  }
  #ExtractHome .el-main {
      overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Extract/ExtractHome_Head.vue